import { Provider } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';

// NOTE: The real ModalController is registered only by provideIonicAngular(),
// which is invoked exclusively by MobileAppModule. Non-mobile clients
// (web/td/sf/td-sf/es01) still pull in shared components and services that
// reference ModalController through their import graph. Without an explicit
// provider, Angular throws NG0201 the moment those classes are instantiated
// — even when their drawer paths are gated by isMobile checks — because the
// injection happens at construction time.
//
// This no-op provider is the safety net: it satisfies the injector for any
// non-optional inject(ModalController) call in shared code, while keeping the
// real Ionic behaviour on mobile. Components and services should still gate
// their actual modal calls behind isMobile / optional checks; the stub is
// intentionally inert and must not be relied on for any real UI behaviour.
class NoOpModalController {
  async create(): Promise<HTMLIonModalElement> {
    return noOpModalElement();
  }
  async dismiss(): Promise<boolean> {
    return false;
  }
  async getTop(): Promise<HTMLIonModalElement | undefined> {
    return undefined;
  }
}

function noOpModalElement(): HTMLIonModalElement {
  const stub = {
    present: () => Promise.resolve(),
    dismiss: () => Promise.resolve(true),
    onDidDismiss: () => Promise.resolve({ data: undefined, role: undefined }),
    onWillDismiss: () => Promise.resolve({ data: undefined, role: undefined }),
  };
  return stub as unknown as HTMLIonModalElement;
}

export function provideNoOpModalController(): Provider {
  return { provide: ModalController, useClass: NoOpModalController };
}
